import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUpdateExpirationDate = () => {
  const queryClient = useQueryClient();
  const local = process.env.REACT_APP_PROXY_PREFIX || '';
  
  return useMutation({
    mutationFn: async ({ expirationDate, ids }) => {
      const result = await restClient({ 
        url: `${local}/users/expiration-date`, 
        method: 'put',
        data: { expirationDate, ids }
      });
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    }
  });
};
